import { createContext } from 'react';

export const HoverContext = createContext<{
	hoverPath: string | null;
	setHoverPath: ((path: string) => void) | null;
}>({
	hoverPath: null,
	setHoverPath: null
});
